export enum CandidateActions {
  // Arrived on the app
  Arrived = 'Arrived',
  // Clicked on job details
  Clicked = 'Clicked',
  // Started the funnel
  StartedRegistration = 'StartedRegistration',
  // Completed the funnel but didn't register
  FilledRegistration = 'FilledRegistration',
  // Finished setting the password
  CompletedRegistration = 'CompletedRegistration',
  // Confirmed their email (also tied to Finished setting the password)
  Subscribed = 'Subscribed',
  // Clicked unsubscribe on an email
  Unsubscribed = 'Unsubscribed',
}
